// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".o2plan--Bk1cb {\n  width: 3rem;\n}\n\n.cls0--rk5s2 {\n  fill: #0112aa;\n}\n\n.st0--s5397 {\n  fill: #169bed;\n}\n\n.st1--gP37F {\n  fill: #ffffff;\n}\n\n.st2--Aya54 {\n  fill: #000;\n}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Networks/O2Plan.com/index.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".o2plan {\n  width: 3rem;\n}\n\n.cls0 {\n  fill: #0112aa;\n}\n\n.st0 {\n  fill: #169bed;\n}\n\n.st1 {\n  fill: #ffffff;\n}\n\n.st2 {\n  fill: #000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"o2plan": "o2plan--Bk1cb",
	"cls0": "cls0--rk5s2",
	"st0": "st0--s5397",
	"st1": "st1--gP37F",
	"st2": "st2--Aya54"
};
export default ___CSS_LOADER_EXPORT___;
